export default "__VITE_ASSET__3e4c798b__"